import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UiService } from '../../core/services/core.ui.service';
import { GfTranslateService } from '../../core/services/core.translate.service';
import * as _ from 'lodash';
@Component({
    selector: 'gf-send-notification',
    template: require('./gf-send-notification.component.html'),
  })
  export class SendNotificationComponent implements OnInit {
    @Input() project: any;
    @Input() context: string;
  
    notification: any = {};
    errors: any = {};
    isSiteContext: boolean;
  
    constructor(
      private httpClient: HttpClient,
      private uiService: UiService,
      private translateService: GfTranslateService
    ) {
      this.resetErrors();
    }
  
    ngOnInit() {
      this.notification = {};
      this.isSiteContext = this.context === 'site';
  
      this.setNotificationObject();
    }
  
    resetErrors() {
      this.errors = {
        subject: {
          hasError: false,
          error: ''
        },
        body: {
          hasError: false,
          error: ''
        },
        target: {
          hasError: false,
          error: ''
        }
      };
    }
  
    setNotificationObject() {
      this.notification = {
        subject: '',
        body: '',
        section: 'project',
        projectAdmins: this.isSiteContext ? false : true,
        siteAdmins: this.isSiteContext,
        dryRun: this.isSiteContext,
        projectMembers: false,
        projectId: !_.isEmpty(this.project) ? this.project.id : 0
      };
    }
  
    validateParameters() {
      this.resetErrors();
  
      if (!_.trim(this.notification.subject)?.length) {
        this.errors.subject.hasError = true;
        this.errors.subject.error = 'Subject cannot be empty';
      }
  
      if (!_.trim(this.notification.body)?.length) {
        this.errors.body.hasError = true;
        this.errors.body.error = 'Body cannot be empty';
      }

      if (this.isSiteContext && !this.notification.projectAdmins && !this.notification.siteAdmins) {
        this.errors.target.hasError = true;
        this.errors.target.error = 'You must select at least one target audience';
      }

      if (!this.isSiteContext && !this.notification.projectAdmins && !this.notification.projectMembers) {
        this.errors.target.hasError = true;
        this.errors.target.error = 'You must select at least one target audience';
      }
  
      return !(this.errors.subject.hasError || this.errors.body.hasError);
    }
  
    sendNotification() {
      if (!this.validateParameters()) {
        this.uiService.message.showError(
          this.translateService.translate('Please verify your form, subject and body cannot be empty')
        );
        return false;
      }
  
      if (this.isSiteContext) {
        this.notification.section = 'admin';
      }
      if (this.notification.dryRun === false) {
        this.notification.dryRun = 'N';
      }

      this.httpClient.post(`/api/sitenotification`, this.notification)
      .toPromise()
      .then((res: any) => {
        if (_.get(res, 'succeeded', true)) {
          this.uiService.message.showSuccess(
            this.translateService.translate('Your communication has been sent')
          );
        } else {
          this.errors = res;
          this.uiService.message.showError(
            this.translateService.translate('There was a problem sending your communication')
          );
        }

        // Reset notification subject & body
        this.notification.subject = '';
        this.notification.body = '';
      }, (err: any) => {
        this.uiService.message.showError(
          this.translateService.translate('There was a problem sending your communication')
        );
      });
    }
  
    resetNotification() {
      this.setNotificationObject();
    }
  
    toggleProjectAdmins() {
      this.notification.projectAdmins = !this.notification.projectAdmins;
    }
  
    toggleSiteAdmins() {
      this.notification.siteAdmins = !this.notification.siteAdmins;
    }
  
    toggleProjectMembers() {
      this.notification.projectMembers = !this.notification.projectMembers;
    }
  
    toggleDryRun() {
      this.notification.dryRun = !this.notification.dryRun;
    }
  }
  
